import { render, staticRenderFns } from "./OzBaseSnackbar.vue?vue&type=template&id=a27e1d28&"
import script from "./OzBaseSnackbar.vue?vue&type=script&lang=ts&"
export * from "./OzBaseSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OzBaseSnackbar.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports